<template>
  <KemudahanAsasBase :amenity="amenity" />
</template>

<script>
// Kutipan Sampah — Peratusan isi rumah mengikut kaedah kutipan sampah. Sub-kategori:
// Tempat kediaman / Kawasan / Tiada (rujuk Lampiran 4). All UI, filters and export
// live in KemudahanAsasBase; this page only supplies the config.
import KemudahanAsasBase from "./KemudahanAsasBase.vue";

export default {
  name: "KutipanSampah",
  components: { KemudahanAsasBase },
  data() {
    return {
      amenity: {
        key: "sampah",
        endpoint: "getKutipanSampahLampiran",
        icon: "mdi-trash-can",
        title: "Kutipan Sampah",
        subtitle: "Peratusan isi rumah mengikut kaedah kutipan sampah, strata dan daerah pentadbiran",
        cardTitle: "Peratusan Isi Rumah mengikut Kutipan Sampah",
        exportTitle: "PERATUSAN ISI RUMAH MENGIKUT KUTIPAN SAMPAH",
        subCategories: ["Tempat kediaman", "Kawasan", "Tiada"],
        sheetName: "Kutipan Sampah",
        fileSlug: "Peratusan_Isi_Rumah_Kutipan_Sampah",
      },
    };
  },
};
</script>
